export const cx = (...a) => a.filter(Boolean).join(' ')
